import * as React from 'react';
import { compose, lifecycle, withProps } from 'recompose';
import { get } from 'lodash';
import Backup from 'material-ui/svg-icons/action/backup';
import AttachMoney from 'material-ui/svg-icons/editor/attach-money';
import Clear from 'material-ui/svg-icons/content/clear';
import CompareArrows from 'material-ui/svg-icons/action/compare-arrows';

import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { ModalButton } from '@components/modalButton/ModalButton';
import { TicketsGenerateForm } from '@modules/tickets/TicketsGenerateForm';
import { TicketsHandOverForm } from '@modules/tickets/TicketsHandOverForm';
import { TicketsMoveForm } from '@modules/tickets/TicketsMoveForm';
import { TicketsCancelForm } from '@modules/tickets/TicketsCancelForm';
import { getHandOverReportTemplate, getMoveReportTemplate } from '@modules/tickets/_ticketsActions';
import { EnhancedExportButton } from '@components/exportButton/ExportButton';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';

const enhance = compose<any, any>(
  lifecycle({
    async componentDidMount() {
      const handOverTemplate = await getHandOverReportTemplate();
      if (!get(handOverTemplate, 'id')) {
        alert('Pro odevzdání hotovosti je třeba vytvořit report s lokací "Záznam o odevzdaných blocích"');
      }
      // move template is optional
      const moveTemplate = await getMoveReportTemplate();
      this.setState({ handOverTemplate });
      this.setState({ moveTemplate });
    }
  })
);

const View = ({
  refresh,
  handOverTemplate,
  moveTemplate,
  state: { sort, order, page, pageSize, filters, checkedItems, universalFilter }
}) => {
  const params = { sort, order, page, pageSize, filters, checkedItems, universalFilter };
  return (
    <React.Fragment>
      <ColumnManager agenda={Agenda.TICKETS} />
      <EnhancedExportButton location={'ticketOverview'} params={params} />
      <div style={{ height: 20, marginLeft: 5 }}>
        {[
          {
            label: 'Generovat řadu bloků',
            icon: <Backup />,
            ModalComponent: TicketsGenerateForm
          },
          {
            label: 'Odevzdat hotovost',
            icon: <AttachMoney />,
            ModalComponent: withProps({ handOverTemplate })(TicketsHandOverForm),
            disabled:
              !get(handOverTemplate, 'id') ||
              checkedItems.length === 0 ||
              checkedItems.some(ticket => ticket.state !== 'USED_BNZ')
          },
          {
            label: 'Stornovat bloky',
            icon: <Clear />,
            disabled: checkedItems.length === 0 || checkedItems.some(ticket => ticket.state !== 'ISSUED'),
            ModalComponent: TicketsCancelForm
          },
          {
            label: 'Přesunout bloky',
            icon: <CompareArrows />,
            ModalComponent: withProps({ moveTemplate })(TicketsMoveForm),
            disabled: checkedItems.length === 0
          }
        ].map(({ label, ModalComponent, ...rest }, key) => (
          <ModalButton
            label={label}
            key={key}
            refresh={refresh}
            checkedItems={checkedItems}
            ModalComponent={ModalComponent}
            style={{ marginBottom: 10, marginRight: 10 }}
            dialogStyles={{
              style: { paddingTop: '5vh' },
              contentStyle: {
                paddingTop: 10,
                width: '80vw',
                maxWidth: '100vw',
                transform: 'none'
              },
              bodyStyle: { padding: '0', overflow: 'auto', width: '80vw' }
            }}
            {...rest}
          />
        ))}
        <Button label="Synchronizovat do registrů poplatků" onClick={() => console.log('Synchronization')} />
      </div>
    </React.Fragment>
  );
};

export const ActionBar = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/tickets/TicketsGridButtons.tsx